import { useMutation } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import {
  SourceStage,
  UpdateSourceStageDocument,
} from '~app/graph/generated/graphql'
import CSVImporter from '../../components/Elements/SourcesBulkCSVImporter'

/*
 * CSV file schema
 */

interface CSVColumn {
  id: string
}

const columnSchema = z.object({
  id: z.string().min(1),
})

/**
 * defines how data is extracted from CSV rows by the column name
 */
const parseDataFromRow = (row: unknown): CSVColumn => {
  const parsedData = {
    id: row['Forward ID'],
  }
  return parsedData
}

/*
 * Component
 */

const UploadCancellationCSVButton = ({
  onUploadComplete,
  onError,
}: {
  onUploadComplete: VoidFunction
  onError: (error: Error, durationSeconds?: number) => void
}) => {
  const { t } = useTranslation()

  const [updateSourceStage] = useMutation(UpdateSourceStageDocument)

  return (
    <CSVImporter
      parseDataFromRow={parseDataFromRow}
      schema={columnSchema}
      buttonLabel={t('sources.uploadCSVCancellationButton')}
      onParsed={(columns: CSVColumn[]) =>
        columns.map(({ id }) =>
          updateSourceStage({
            variables: {
              id,
              stage: SourceStage.Canceled,
            },
          })
            .then(mutationResult => {
              if (
                !mutationResult ||
                mutationResult.error ||
                !mutationResult.data
              ) {
                return {
                  error:
                    mutationResult && mutationResult.error
                      ? mutationResult.error.message
                      : 'mutation failed',
                  sourceId: id,
                }
              }
              onUploadComplete()
              return null
            })
            .catch(error => {
              onError(error, 3)
              return { error, sourceId: id }
            })
        )
      }
      onFailure={onError}
    />
  )
}

export default UploadCancellationCSVButton
